import { InlinePopupProps } from "csi/middleware/inline/InlinePopup";
import InlineSingleSelect from "csi/middleware/inline/InlineSingleSelect";
import { ComponentItem } from "designSystem/types/component-item-types";
import React, { FunctionComponent, HTMLAttributes, ReactNode } from "react";
import util from "csi/widget/icon/Util";
import clsx from "clsx";

const TaskActionIconInlineSelect: FunctionComponent<InlinePopupProps> = (props) => {
	function renderOption<T extends ComponentItem>(props: HTMLAttributes<HTMLLIElement>, option: T, { selected }): ReactNode {
		const { id, value } = option;
		const { icon, iconCss } = util.getTaskActionIconCss(value);

		let iconSpanCss: string;
		let iconSpanText: string;
		if (iconCss){
			iconSpanCss = clsx("csi-icon-block", "csi-icon-with-label-icon", "material-icons", "csi-material-icon-" + icon, iconCss);
			iconSpanText = icon;
		} else {
			iconSpanCss = clsx("csi-icon-block", "csi-icon-with-label-icon", "csi-custom-icon", "csi-custom-icon-" + icon);
			iconSpanText = "";
		}

		return (
			<li 
				{...props} 
				data-csi-value={option.value}
				key={id}
			>
				<span className={iconSpanCss}>{iconSpanText}</span>
			</li>
		);
	}

	return (
		<InlineSingleSelect
			customRenderOption={renderOption}
			{...props}
		/>
	);
};

export default TaskActionIconInlineSelect;
